import _ from 'lodash';
import { DateTime } from 'luxon';
import { createActionHelpers } from 'vuex-loading';

/* Mutations */
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_FORM = 'UPDATE_FORM';
export const UPDATE_TABLE_CTX = 'UPDATE_TABLE_CTX';
export const UPDATE_SEARCHED_CESIONES = 'UPDATE_SEARCHED_CESIONES';
export const UPDATE_FIND_RESULT = 'UPDATE_FIND_RESULT';
/* Actions */
export const searchCesionAction = 'searchCesionAction';
export const searchByFilterAction = 'searchByFilterAction';
export const cleanAction = 'cleanAction';

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

function cesionesOperation(operations) {
  const matrix = {};
  _.forOwn(operations, (op, opKey) => {
    if (Array.isArray(op.cesiones) && op.cesiones.length > 0) {
      op.cesiones.forEach((c) => {
        if (!Array.isArray(matrix[c])) {
          matrix[c] = [];
        }
        matrix[c].push(opKey);
      });
    }
  });
  return matrix;
}
function calculateFechaVencimiento(operation, dates, plazos) {
  let tipoPlazoActual;
  let plazoActual;
  let fecha;
  if (plazos && operation.plazo) {
    tipoPlazoActual = plazos.filter(p => p.uuid === operation.plazo);
    plazoActual = operation.plazoNumero ? operation.plazoNumero : 0;
    if (tipoPlazoActual[0] && plazoActual) {
      fecha = DateTime.fromISO(dates.fechaFirmaNotario);
      switch (tipoPlazoActual[0].text) {
        case 'meses':
          fecha = fecha.plus({ months: plazoActual });
          break;
        case 'años':
          fecha = fecha.plus({ years: plazoActual });
          break;
        case 'días':
          fecha = fecha.plus({ days: plazoActual });
          break;
        default:
          break;
      }
    }
  }
  fecha = fecha.plus({ days: -1 });
  return fecha;
}
async function filterByFechaVencimiento(entities, filter, rootGetters) {
  const plazos = await rootGetters['taxonomy/getTaxonomy']('date');
  const dates = await rootGetters['datesAssignements_model/entitiesGetter'];
  let fechaBusqueda;
  let result = null;
  if (Array.isArray(entities) && Object.keys(dates).length > 0) {
    entities.forEach((entity) => {
      if (entity.operacion && entity.operacion.datesAssigments) {
        entity.dates = dates[entity.operacion.datesAssigments];
        entity.fechaVencimiento = calculateFechaVencimiento(entity.operacion, entity.dates, plazos);
      }
    });
    if (filter && filter.value && filter.type) {
      fechaBusqueda = DateTime.fromISO(filter.value);
      if (filter.type === 'desde') {
        result = entities.filter(e => e.fechaVencimiento > fechaBusqueda);
      } else if (filter.type === 'hasta') {
        result = entities.filter(e => e.fechaVencimiento < fechaBusqueda);
      } else {
       // result = entities.filter(e => (e.fechaVencimiento ))
      }
    }
  }
  return result;
}
async function proyectCesionesInversorOperacion(cesiones, rootGetters) {
  const inversores = await rootGetters['inversor_model/entitiesGetter'];
  const operaciones = await rootGetters['operation_model/entitiesGetter'];
  const matrix = cesionesOperation(operaciones);
  const result = [];
  if (Array.isArray(cesiones)) {
    cesiones.forEach((c) => {
      if (matrix[c.id]) {
        matrix[c.id].forEach(op => result.push({
          importe: c.importe,
          cedido: c.fechaCesion,
          recompra: c.fechaDevolucion,
          estado: operaciones[op].state,
          cesion: c.id,
          inversor: inversores[c.inversor],
          operacion: operaciones[op],
        }));
      }
    });
  }
  return result;
}

const initState = {
  error: '',
  loading: false,
  findResult: false,
  formModel: {
    filtro: '',
  },
  tableCtx: {
    currentPage: 1,
    perPage: 10,
    filter: '',
    sortBy: '',
    sortDesc: false,
  },
  searchedCesiones: [],
};

export default {
  namespaced: true,
  state: Object.assign({}, initState),
  mutations: {
    [UPDATE_ERROR](state, error) {
      state.error = error;
    },
    [CLEAR_MODULE](state) {
      Object.assign(state, initState);
    },
    [UPDATE_LOADING](state, loading) {
      state.loading = loading;
    },
    [UPDATE_FORM](state, model) {
      state.formModel = model;
    },
    [UPDATE_FIND_RESULT](state, payload) {
      state.findResult = payload;
    },
    [UPDATE_TABLE_CTX](state, model) {
      state.tableCtx = Object.assign({}, state.tableCtx, model);
    },
    [UPDATE_SEARCHED_CESIONES](state, cesiones) {
      state.searchedCesiones = cesiones;
    },
  },
  actions: {
    [cleanAction]({ commit }) {
      commit(UPDATE_ERROR, '');
      commit(UPDATE_FIND_RESULT, false);
      commit(UPDATE_SEARCHED_CESIONES, []);
      commit(UPDATE_TABLE_CTX, {
        currentPage: 1,
        perPage: 10,
        filter: '',
        sortBy: '',
        sortDesc: false,
      });
    },
    async [searchCesionAction]({ commit, dispatch, rootGetters }, payload) {
      startLoading(dispatch, 'buscar cesiones');
      commit(UPDATE_FORM, payload);
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      let filterFechaVencimiento = null;
      const fetchConfig = {};
      _.forOwn(payload, (value, key) => {
        if (value !== '') {
          if (key === 'nombre') {
            fetchConfig.operationFilter = {
              value,
              operator: 'CONTAINS',
              path: 'title',
              parent: 'node--operation',
              parentProperty: 'cesiones',
            };
          } else if (key === 'inversor') {
            fetchConfig.orInversor = {
              conjunction: 'OR',
            };
            fetchConfig.nombreFilter = {
              operator: 'CONTAINS',
              value,
              path: 'inversor.nombre_inversor',
              memberOf: 'orInversor',
            };
            fetchConfig.apellidosFilter = {
              operator: 'CONTAINS',
              value,
              path: 'inversor.apellidos_inversor',
              memberOf: 'orInversor',
            };
          } else if (key === 'importe') {
            if (_.has(value, 'desde') && value.desde) {
              fetchConfig.importeDesde = {
                modelName: 'importe',
                operator: '>=',
                value: value.desde,
                path: 'importe_inversion',
              };
            }
            if (_.has(value, 'hasta') && value.hasta) {
              fetchConfig.importeHasta = {
                modelName: 'importe',
                operator: '<=',
                value: value.hasta,
                path: 'importe_inversion',
              };
            }
          } else if (key === 'firma') {
            if (_.has(value, 'desde') && value.desde) {
              fetchConfig.fechaDesde = {
                modelName: 'fechaCesion',
                operator: '>=',
                value: value.desde,
                path: 'fecha_cesion',
              };
            }
            if (_.has(value, 'hasta') && value.hasta) {
              fetchConfig.fechaHasta = {
                modelName: 'fechaCesion',
                operator: '<=',
                value: value.hasta,
                path: 'fecha_cesion',
              };
            }
          } else if (key === 'vencimiento') {
            if (_.has(value, 'desde') && value.desde) {
              filterFechaVencimiento = {
                value: value.desde,
                type: 'desde',
              };
            }
            if (_.has(value, 'hasta') && value.hasta) {
              filterFechaVencimiento = {
                value: value.hasta,
                type: 'hasta',
              };
            }
          }
        }
      });
      let entities;
      const getEntities = await dispatch('cesion_model/fetchAction', fetchConfig, { root: true });
      if (getEntities) {
        entities = await proyectCesionesInversorOperacion(getEntities.entities, rootGetters);
      }
      if (filterFechaVencimiento && Array.isArray(entities)) {
        entities = await filterByFechaVencimiento(entities, filterFechaVencimiento, rootGetters);
      }
      if (Array.isArray(entities) && entities.length > 0) {
        commit(UPDATE_SEARCHED_CESIONES, entities);
      } else {
        commit(UPDATE_SEARCHED_CESIONES, []);
      }
      commit(UPDATE_LOADING, false);
      commit(UPDATE_FIND_RESULT, true);
      endLoading(dispatch, 'buscar cesiones');
    },
    [searchByFilterAction]({ commit, dispatch, rootGetters }, payload) {
      startLoading(dispatch, 'buscar cesiones');
      const value = [];
      switch (payload) {
        case 'Cesiones Vivas':
          value.push(rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Análisis' }));
          value.push(rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Firmada' }));
          value.push(rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Pre-aprobada' }));
          value.push(rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Alta' }));
          value.push(rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Condicionada' }));
          value.push(rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Aprobada' }));
          break;
        case 'Cesiones vencidas':
          value.push(rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Cancelada' }));
          value.push(rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Vencida' }));
          value.push(rootGetters['taxonomy/searchTaxonomyValue']({ vid: 'status', text: 'Denegada' }));
          break;
        default:
          break;
      }
      dispatch('cesion_model/fetchAction', {
        state: {
          operator: 'IN',
          value,
          path: 'state.uuid',
          parent: 'node--operation',
          parentProperty: 'cesiones',
        },
      }, { root: true })
        .then(res => proyectCesionesInversorOperacion(res.entities, rootGetters))
          .then((entities) => {
            if (Array.isArray(entities) && entities.length > 0) {
              commit(UPDATE_SEARCHED_CESIONES, entities);
            } else {
              commit(UPDATE_SEARCHED_CESIONES, []);
            }
            commit(UPDATE_LOADING, false);
            commit(UPDATE_FIND_RESULT, true);
            endLoading(dispatch, 'buscar cesiones');
          });
    },
  },
  getters: {
    isLoading: state => state.loading,
    error: state => state.error,
    searchedCesiones: state => state.searchedCesiones,
    existError: state => state.error !== '',
    findResult: state => state.findResult,
  },
};



// WEBPACK FOOTER //
// ./src/features/menu-cesiones/store.js